import * as Stimulus from "@hotwired/stimulus"

export class RequiredRepeaterController extends Stimulus.Controller {
    static values = {
        errorMessage: String
    }

    validate(event) {
        const hasItem = Array.from(
            this.element.querySelectorAll('[data-repeater-target="indicesField"]')
        ).some(input => input.value.length > 0);

        if (hasItem) {
            this.dispatch("clear", { prefix: "form" });
            return;
        }

        this.dispatch("invalid", {
            prefix: "form",
            detail: {
                errorMessage: this.errorMessageValue || "Please add at least one item."
            }
        });
        event.preventDefault();
    }
}
